import React from 'react'
import styled from 'styled-components'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  z-index: 2000;
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
`

const ModalContainer = styled.div`
  position: relative;
  width: calc(100% - 4rem);
  max-width: 480px;
  margin: auto;
`

const Modal = styled.div`
  background: var(--color-background);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  position: relative;
  overflow: hidden;
  transform: translateY(${props => props.$isOpen ? '0' : '20px'});
  opacity: ${props => props.$isOpen ? '1' : '0'};
  transition: transform 0.3s ease, opacity 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(
      90deg,
      var(--color-primary),
      var(--color-secondary)
    );
  }
`

const Header = styled.div`
  padding: 2rem;
  text-align: center;
`

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, var(--color-text) 0%, var(--color-primary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const Subtitle = styled.p`
  color: var(--color-text-secondary);
  font-size: 1.125rem;
  line-height: 1.6;
`

const Content = styled.div`
  padding: 0 2rem 2rem;
`

const Option = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: translateY(-2px);
  }

  h3 {
    color: var(--color-text);
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  p {
    color: var(--color-text-secondary);
    font-size: 0.875rem;
    line-height: 1.6;
  }
`

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0.5rem;
  transition: all 0.2s ease;

  &:hover {
    color: var(--color-text);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

const Divider = styled.div`
  margin: 1.5rem 0;
  text-align: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
  }

  span {
    background: var(--color-background);
    padding: 0 1rem;
    color: var(--color-text-secondary);
    font-size: 0.875rem;
    position: relative;
  }
`

function WalletModal({ isOpen, onClose, onConnect, onEnterDemo }) {
  const handleDemoClick = () => {
    onEnterDemo()
    onClose()
  }

  return (
    <Overlay $isOpen={isOpen} onClick={onClose}>
      <ModalContainer>
        <Modal $isOpen={isOpen} onClick={e => e.stopPropagation()}>
          <CloseButton onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </CloseButton>

          <Header>
            <Title>Connect Your Wallet</Title>
            <Subtitle>
              Choose how you want to experience the platform
            </Subtitle>
          </Header>

          <Content>
            <Option onClick={onConnect}>
              <h3>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
                </svg>
                Connect Phantom Wallet
              </h3>
              <p>
                Connect your Solana wallet to deploy real projects and save your configurations.
              </p>
            </Option>

            <Divider>
              <span>or</span>
            </Divider>

            <Option onClick={handleDemoClick}>
              <h3>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
                </svg>
                Try Demo Mode
              </h3>
              <p>
                Experience the platform features in a simulated environment without connecting a wallet.
              </p>
            </Option>
          </Content>
        </Modal>
      </ModalContainer>
    </Overlay>
  )
}

export default WalletModal
